import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getStats(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('https://admin.ordredespharmaciens.sn/api/v1/dashboard/stats')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getListTransactions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('https://admin.ordredespharmaciens.sn/api/v1/transactions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/user/users', { user: userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
